/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

/**
 * The access level of the comment
 */
export enum FetchCommentResponseAccessLevel {
  public= 'public',
  internal= 'internal',

}